import { Col, Form, Row } from "react-bootstrap";

interface IEpaField {
  label: string;
  value: string | JSX.Element;
  labelClassName?: string;
  valueClassName?: string;
}

const EpaField = ({
  label,
  value,
  labelClassName,
  valueClassName,
}: IEpaField) => {
  if (!labelClassName) labelClassName = "col-4 col-md-4";

  if (!valueClassName) valueClassName = "col-8 col-md-8";

  return (
    <Row>
      <Col className={labelClassName}>
        <Form.Label>{label}</Form.Label>
      </Col>
      <Col className={valueClassName}>{value}</Col>
    </Row>
  );
};

export default EpaField;
